<template>
<div >
	<Navbar></Navbar>

	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card">
				<div class="card-body">

			
					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Traslados</li>
						</ol>
						<div class="title">
							<h1>Traslados</h1>
						</div>
						
						<div class="cta">
							<router-link :to="`/transfers/request-transfers`" tag="a" class="btn btn-light " >Solicitar traslados</router-link>
						</div>
					</div>

			
					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
						
						<!-- <div class="filter">
							<label>Estado</label>
							<select class="form-control" 
								v-model="filters.status" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="PRE_ADMITTED">Pre ingresados</option>
								<div class="dropdown-divider"></div>
								<option value="IN_CUSTOMS_DEPOSIT">Depósito fiscal</option>
								<option value="CUSTOMS_DISPATCH_PENDING"> - Sin despachar</option>
								<option value="CUSTOMS_DISPATCHED"> - Despachados</option>
								<div class="dropdown-divider"></div>
								<option value="IN_NATIONAL_DEPOSIT">Depósito nacional</option>
								<option value="PRE_DELIVERY_PENDING"> - Sin pre-entrega</option>
								<option value="PRE_DELIVERY_DONE"> - Pre entregas realizada</option>
								<div class="dropdown-divider"></div>
								<option value="DELIVERY_REQUESTED">Entregas solicitadas</option>
								<option value="DELIVERY_SCHEDULED">Entregas programadas</option>
								<option value="DELIVERED">Entregados</option>
							</select>           
						</div> -->
						
						<!-- <div class="filter">
							<label>Cliente</label>
							<select class="form-control" 
								v-model="filters.client_id" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option v-for="client in clients" :key="client.id" :value="client.id">{{client.name}}</option>
							</select>           
						</div> -->

					</div>
				
					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Chasis</td>
							<td>Vehículo</td>
							<td>Inicio</td>
							<td>Cierre</td>
							<!-- <td>Cliente</td> -->
							<td>Estado</td>
						</tr>
						
						<tr v-for="item of list" :key="item.id" @click="openPreview(item.id)" >
							<td>{{item.chassis_number}}</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.brand}}</span>
									<span >{{item.model}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary" v-if="item.checkOut">{{item.checkOut | moment("DD-MM-YYYY HH:mm")}}</span>
									<span v-if="item.checkOutLocation">{{item.checkOutLocation}}</span>
								</div>
							</td>
							<td>
								<div class="tc" v-if="item.checkIn">
									<span class="text-primary" >{{item.checkIn | moment("DD-MM-YYYY HH:mm")}}</span>
									<span >{{item.checkInLocation}}</span>
								</div>
								<div class="tc" v-else>
									<span class="text-secondary" >No definida</span>
								</div>
							</td>
							<!-- <td>
								<div class="tc">
									<span class="text-primary" v-if="item.client">{{item.client.name}}</span>
									<span v-if="item.client">{{item.client.business_name}}</span>
								</div>
							</td> -->
							<td>
								<div class="tc">
									<span><div class="car-status-point" :class="{'DELIVERED':item.status=='ON_COURSE'}"></div>{{item.statusText}}</span>
									
								</div>
							</td>
						</tr>
						
					</table>

					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado traslados</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>
		
				</div>
			</div>
		</div>
	</div>
	

	<TransferPreview ref="transferPreview"></TransferPreview>
	
</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'
import { mapGetters } from 'vuex'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import TransferPreview from './TransferPreview'

export default {
	name: 'transfers',
	components:{
		Navbar,
		Loader,
		TransferPreview,
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			clients:[],
			loading: true,
		}
	},
	computed:{
		...mapGetters(['loggedUser'])
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		// this.fetchaData();
		this.load();
	},
	methods:{
		
		// fetchaData(){
		// 	this.$apollo.query({
		// 		query: gql`query ($id: ID! ) {
		// 			user(id: $id) {
		// 				id
		// 				clients{
		// 					id
		// 					name
		// 				}
		// 			}
		// 		}`,
		// 		variables: {
		// 			id: this.loggedUser.id,
		// 		},
		// 		fetchPolicy: 'no-cache'
		// 	})
		// 	.then(({data}) => {
		// 		this.clients = data.user.clients;
		// 	});
		// },


		load(){
			this.$apollo.query({
				query: gql`query ($first: Int!, $page: Int, $search: String, $status: String, $client_id: ID) {
					transfers(first: $first, page: $page, search: $search, status: $status, client_id: $client_id) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							client{
								name
								business_name
							}
							checkOut
							checkIn
							checkOutLocation
    						checkInLocation
							brand
							model
							chassis_number
							status
							statusText								
						}
					}
				}`,
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
					status: this.filters.status,
					client_id: this.filters.client_id,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.list = data.data.transfers.data;
				this.pagination.total = data.data.transfers.paginatorInfo.total;
				this.loading = false
			});
		},

		openPreview(id){
			this.$refs.transferPreview.open(id)
		},
		
	}
}

</script>

<style>

</style>
